import React from 'react';
import { IProps as IFiftyFiftyImageLinksBlockProps } from './FiftyFiftyImageLinksBlock.interface';
import { FiftyFiftyImageLinksBlock } from './FiftyFiftyImageLinksBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

/**
 * Input props expected from an external source (e.g., CMS).
 * This interface mirrors the structure of props expected for the component,
 * but allows for mapping or transformation if needed.
 */
export interface IFiftyFiftyImageLinksBlockInputProps {
    heading?: string;
    content?: string;
    image: {
        alternateText: string;
        defaultSrc: string;
        sizesAttribute: string[];
        srcSet: string[];
        srcSetWebp: string[];
        isBackground: boolean;
        textContent: string;
        isLazy: boolean;
    };
    imageDescription: string;
    links: {
        text: string;
        target: string | null;
        href: string;
        title: string | null;
        ariaLabel: string | null;
    }[];
    background: ThemeColors;
    mediaPosition: 'left' | 'right';
    [key: string]: any; // Allow passthrough of other props
}

/**
 * Maps input props from an external source to the component's props.
 * Adjust this function to handle any necessary transformations.
 */
const mapInputToProps = (
    input: IFiftyFiftyImageLinksBlockInputProps
): IFiftyFiftyImageLinksBlockProps => {
    return {
        ...input,
        heading: input.heading || undefined,
        text: input.content || undefined,
        image: translation.mapImageProps(input.image),
        caption: input.imageDescription,
        buttons: input.links?.map((link) => translation.mapAnchorProps(link)),
        mediaPosition: input.mediaPosition || 'right',
        background: input.background || 'white',
        className: input.parentClass,

    } as IFiftyFiftyImageLinksBlockProps; // Ensure the return type matches
};

/**
 * Translation component for FiftyFiftyImageLinksBlock.
 * This component maps external input props to the component's props
 * and renders the FiftyFiftyImageLinksBlock component.
 */
const FiftyFiftyImageLinksBlockTranslation: React.FC<IFiftyFiftyImageLinksBlockInputProps> = (
    inputProps
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FiftyFiftyImageLinksBlock}
        mapProps={mapInputToProps}
    />
);

export default FiftyFiftyImageLinksBlockTranslation;